'use client'

import { useTranslations } from 'next-intl'

import TrackingOptionToggle from './TrackingOptionToggle'
import { TrackingType } from './CookieBanner.types'

interface Props {
  showCookiePreferences: boolean
  trackingPreferences: { [key in TrackingType]: boolean }
  toggleOption: (type: TrackingType) => (event: React.ChangeEvent<HTMLInputElement>) => void
}

const TrackingOptions = ({ showCookiePreferences, trackingPreferences, toggleOption }: Props) => {
  const t = useTranslations('cookies')
  if (showCookiePreferences) {
    return (
      <>
        <p className="text-center text-base">{t('long-description')}</p>
        <div className="flex flex-col gap-4">
          <TrackingOptionToggle type="ESSENTIAL" isChecked />
          <TrackingOptionToggle
            type={TrackingType.ANALYTICS}
            isChecked={trackingPreferences[TrackingType.ANALYTICS]}
            toggleOption={toggleOption}
          />
          <TrackingOptionToggle
            type={TrackingType.ADVERTISING}
            isChecked={trackingPreferences[TrackingType.ADVERTISING]}
            toggleOption={toggleOption}
          />
        </div>
      </>
    )
  }

  return <p className="text-center text-base">{t('long-description')}</p>
}

export default TrackingOptions
